export const errorJSON = {
    ALPHA: "Enter only the alphabets",
    BLANK: "This field is required",
    VALIDNUMBER: "Enter only numeric character",
    ZIPCODE: "Enter valid zip code",
    PHONENUMBER: "Enter valid phone number",
    EMAIL: "Enter valid email id",
    EMAILNOMATCH: "Email id not matching",
    DROPDOWNLIST: "Please select from list",
    SECURITYANSWER: "Security answer not matching",
    PASSWORDNOMATCH: "Password not matching",
    CHECKBOX: "Check box is not checked",
	SECUREPASSWORD:"Password not matching the criteria"
}


// WEBPACK FOOTER //
// ./src/utils/errorMessage.js